import { useState } from "react";
import { Trash2, FolderOpen, Plus, Save } from "lucide-react";
import { Input } from "@/components/ui/input";

function eur(n) { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Math.round(n || 0)); }

export default function SavedBudgets({ list, current, onLoad, onDelete, onNew, onSave }) {
  const [search, setSearch] = useState("");
  const filtered = list.filter(b => !search || (b.clientName || "").toLowerCase().includes(search.toLowerCase()) || (b.workType || "").toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="rounded-2xl border border-slate-200 dark-border bg-white dark-bg-card overflow-hidden">
      <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-slate-100 dark-border">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-slate-500 dark-text-mid font-semibold">Presupuestos</div>
          <div className="font-display font-semibold text-slate-900 dark-text-strong text-base">Historial guardado</div>
        </div>
        <div className="flex items-center gap-1.5">
          <button
            type="button"
            onClick={onSave}
            data-testid="save-budget-btn"
            className="inline-flex items-center gap-1.5 h-8 px-2.5 rounded-md bg-emerald-600 text-white text-xs font-medium hover:bg-emerald-700 transition-colors"
          >
            <Save className="w-3.5 h-3.5" />
            Guardar
          </button>
          <button
            type="button"
            onClick={onNew}
            data-testid="new-budget-btn"
            className="inline-flex items-center gap-1.5 h-8 px-2.5 rounded-md border border-slate-200 dark-border text-slate-600 dark-text-mid text-xs font-medium hover:border-slate-300 transition-colors"
          >
            <Plus className="w-3.5 h-3.5" />
            Nuevo
          </button>
        </div>
      </div>

      <div className="px-5 py-3 border-b border-slate-100 dark-border">
        <Input
          placeholder="Buscar por cliente u obra…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          data-testid="saved-search"
          className="h-9 text-sm focus-visible:ring-emerald-500 focus-visible:ring-offset-0 dark-bg-section dark-text-strong dark-border"
        />
      </div>

      <div className="max-h-[420px] overflow-y-auto" data-testid="saved-list">
        {filtered.length === 0 ? (
          <div className="px-5 py-10 text-center text-sm text-slate-400 dark-text-mid">
            <FolderOpen className="w-6 h-6 mx-auto mb-2 opacity-50" />
            No hay presupuestos {search ? `que coincidan con "${search}"` : 'guardados todavía'}.
          </div>
        ) : (
          <div className="divide-y divide-slate-100 dark-border">
            {filtered.map(b => {
              const isCurrent = b.id === current;
              return (
                <div
                  key={b.id}
                  data-testid={`saved-item-${b.id}`}
                  className={["px-5 py-3 flex items-center justify-between gap-2 cursor-pointer transition-colors", isCurrent ? "bg-emerald-50 dark-bg-section" : "hover:bg-slate-50 dark-bg-section-hover"].join(" ")}
                  onClick={() => onLoad(b.id)}
                >
                  <div className="min-w-0 flex-1">
                    <div className="text-sm font-medium text-slate-900 dark-text-strong truncate">
                      {b.clientName || 'Cliente sin nombre'}
                    </div>
                    <div className="text-[11px] text-slate-500 dark-text-mid truncate">
                      {b.workType || 'Reforma'} · {b.surface} m² · {new Date(b.updatedAt || Date.now()).toLocaleDateString('es-ES')}
                    </div>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="text-sm font-display font-bold text-emerald-600 tabular-nums">
                      {eur(b.totalConIva || 0)}
                    </div>
                    <button
                      type="button"
                      onClick={(e) => { e.stopPropagation(); onDelete(b.id); }}
                      data-testid={`delete-budget-${b.id}`}
                      className="text-slate-300 hover:text-red-500 transition-colors"
                      aria-label="Eliminar"
                    >
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
